import React from "react";

import { Search } from "@mui/icons-material";
import { FormControl, InputAdornment, TextField } from "@mui/material";

const SearchInput = ({ value, onChange, startAdornment, size, inputStyles = {}, containerStyles = {}, ...props }) => {
  return (
    <FormControl sx={{ width: "auto", ...containerStyles }}>
      <TextField
        size={size}
        value={value}
        sx={{
          bgcolor: "#fff",
          border: "1px solid #DDDDDD",
          borderRadius: "6px",
          "& fieldset": { border: "none" },
        }}
        // onChange={handleChange}
        slotProps={{
          input: {
            sx: { height: '46px', fontSize: { xs: "14px", md: "16px" }, ...inputStyles },
            endAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: "#999" }} />
              </InputAdornment>
            ),
            startAdornment: startAdornment,
          }
        }}
        onChange={(e) => onChange(e.target.value)}
        {...props}
      />
    </FormControl>
  );
};

SearchInput.defaultProps = {
  placeholder: "Search...",
  size: "small",
};

export default SearchInput;
